<script setup lang="ts">
import { webchatPrices } from '~/data/prices/webchat';

const props = defineProps<{
    title: string,
    desc: string,
}>();
</script>

<template>
    <SectionsPricesBase :title="props.title" :desc="props.desc">
        <div class="w-full flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-8 mt-10 lg:mt-15">
            <LazyCardsPricing
                v-for="item in webchatPrices"
                :key="item.title"
                :item="item"
                primaryBtn
            />
        </div>
    </SectionsPricesBase>
</template>